module.exports = __webpack_public_path__ + "static/media/username.06019952.svg";